import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const BlockingSessionApi = {
    fetchTime: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/blocking/session/time?${timeRangeQS}&id=${instanceId}`),
    fetchSessionTime: (timeRangeQS: string, instanceId: number, sessionId: string): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/blocking/session/time?${timeRangeQS}&id=${instanceId}&session=${encodeURIComponent(sessionId)}`),
    fetch: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/blocking/session?${timeRangeQS}&id=${instanceId}`),
};

export default BlockingSessionApi;
